import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import FreelancerDetailView from "./FreelancerDetailView";
import FreelancerPublicView from "./FreelancerPublicView";

export default function FreelancerProfileRoute({ isProductionHouse, token }) {
  const { freelancerId } = useParams();
  const navigate = useNavigate();
  if (isProductionHouse) return <FreelancerDetailView token={token} />;
  return <FreelancerPublicView freelancerId={freelancerId} token={token} onBack={() => navigate(-1)} />;
}
